var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[(_vm.$route.name === 'RiverTemp')?[_c(_setup.MainMenu)]:_vm._e(),_c('router-view')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }